<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey2 rs-flex rs-flex-dir-col">
    <h2 class="rs-tit5">{{'nortonFamily.details.account.title' | translate }}</h2>
    <p>{{ 'nortonFamily.details.account.description' | translate }}
    </p>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <div class="rs-maxw small-only-text-center">
        <a href="{{ 'nortonFamily.details.account.login.url' | translate }}" target="_blank" data-tms-event="link-click"
          attr.data-tms-link-zone="{{ 'nortonFamily.details.account.title' | translate }}"
          attr.data-tms-link-name="{{ 'nortonFamily.details.account.login.label' | translate }}"
          attr.data-tms-link-url="{{ 'nortonFamily.details.account.login.url' | translate }}"
          class="rs-btn rs-btn-second "> {{ 'nortonFamily.details.account.login.label' | translate }}</a>
        <p><a href="{{ 'nortonFamily.subscription.button.cancel.link' | translate }}" target="_blank"
            data-tms-event="link-click" attr.data-tms-link-zone="{{ 'nortonFamily.subscription.title' | translate }}"
            attr.data-tms-link-name="{{ 'nortonFamily.details.account.cancel.subscription.label' | translate }}"
            attr.data-tms-link-url="{{ 'nortonFamily.subscription.button.cancel.link' | translate }}">{{
            'nortonFamily.details.account.cancel.subscription.label' | translate }}</a></p>
      </div>
    </div>
  </div>
</div>